
import {WOW} from '../../../node_modules/wowjs/dist/wow';



new WOW().init();

const observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (entry.isIntersecting) {
const img = entry.target;
img.src = img.dataset.src;
observer.unobserve(img);
}
});
}, { rootMargin: '200px' }); // 预加载200px
document.querySelectorAll('img[data-src]').forEach(img => observer.observe(img));

$(".pop input").focus(function() {
    $(this).css("border","1px solid #0062AD")
})
$(".pop input").blur(function() {
    $(this).css("border","none")
})
$(".pop textarea").focus(function() {
    $(this).css("border","1px solid #0062AD")
})
$(".pop textarea").blur(function() {
    $(this).css("border","none")
})
$(".pop-btn").click(function() {
    $(".pop").css('display','flex');
})
$(".pop .model").click(function() {
    $(".pop").hide();
})
$(".pop .out").click(function() {
    $(".pop").hide();
})
$(".download-btn").click(function() {
    $(".download-pop").css("display","flex");
})
$(".download-pop .out").click(function() {
    $(".download-pop").hide();
})
$(".download-pop .model").click(function() {
    $(".download-pop").hide();
})